import React from 'react';
import { getSizeInfo } from '../../data/sizeReference';
import PoloImage from '../PoloImage/PoloImage';
import styles from './WorkwearPreview.module.css';

const POLO_SRC = {
  male: '/assets/black.png',
  female: '/assets/white.png',
};

/**
 * 工装玩偶预览：白/黑 Polo 照片，XL 为基准，宽高分别微调
 */
export default function WorkwearPreview({ gender = 'male', size = 'L', showBadge = true }) {
  const sizeInfo = getSizeInfo(size);
  const { scaleX, scaleY } = sizeInfo;
  const src = POLO_SRC[gender] || POLO_SRC.male;
  const alt = gender === 'female' ? '白色工装预览' : '黑色工装预览';

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.figureStage}
        style={{ transform: `scale(${scaleX}, ${scaleY})` }}
      >
        <PoloImage className={styles.figure} src={src} alt={alt} draggable={false} />
      </div>
      {showBadge && (
        <div className={styles.sizeBadge}>
          <span className={styles.sizeLabel}>{size}</span>
          <span className={styles.friendlyName}>{sizeInfo.friendlyName}</span>
        </div>
      )}
    </div>
  );
}
